import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	roadmapTabLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.roadmap-tab-label',
		defaultMessage: 'Roadmap',
		description: 'The label to display for the Roadmap tab',
	},
	teamsTabLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.teams-tab-label',
		defaultMessage: 'Teams',
		description: 'The label to display for the Teams tab',
	},
	releasesTabLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.releases-tab-label',
		defaultMessage: 'Releases',
		description: 'The label to display for the Releases tab',
	},
	dependenciesTabLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.dependencies-tab-label',
		defaultMessage: 'Dependencies report',
		description: 'The label to display for the Dependencies tab',
	},
	planAndTimeline: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.plan-and-timeline',
		defaultMessage: 'Plan and timeline',
		description: 'Section name for plan and timeline',
	},
	plans: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.plans',
		defaultMessage: 'Plans',
		description: 'Used for the document title',
	},
	releasesSearchPlaceholder: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.releases-search-placeholder',
		defaultMessage: 'Search releases',
		description: 'Placeholder text for Releases search field',
	},
	searchLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.search-label',
		defaultMessage:
			'Typing letters in this search field input updates the releases search results.',
		description:
			'Label for the text field notifying users that typing letters on the search field would filter the releases results.',
	},
});
